var moduleAnchor = window.EDMDataStorage.moduleAnchor;

if(moduleAnchor.anchor) {
    var entryId = '#' + moduleAnchor.anchor;
    $(window).scrollTop($(entryId).offset().top);
}


//////////////////
// WEBPACK FOOTER
// ./src/interlock/core-page/module-anchor/module-anchor.js
// module id = 95
// module chunks = 0 1 3 6 8 11 12 14